export const SCENE_LIMITS = Object.freeze({
  maxNodes: 10000,
  maxRuntimeNodes: 50000,
  maxDepth: 64,
  maxDefinitions: 500,
  maxRepeats: 200,
  maxDataViews: 200,
  maxLayouts: 200,
  maxRelations: 5000,
  maxStates: 200,
  maxTimelines: 200,
  maxTimelineSteps: 5000,
  maxInteractions: 1000,
  maxConstructs: 500,
  maxAggregateOps: 20,
  maxPathLength: 20000,
  maxPathCommands: 2000,
  maxPoints: 100000,
  maxTextLength: 1000,
  maxMetadataEntries: 200,
  maxAssets: 500,
  maxSpriteFrames: 240,
  maxFiltersPerNode: 4,
  maxLayoutIterations: 300,
  maxForceLayoutNodes: 500,
  maxDagLayoutNodes: 2000,
  maxReconcileOperations: 100000,
  maxDevicePixelRatio: 2,
  maxWorldSize: 100000,
  maxTextureDimension: 8192,
  maxAssetUrlLength: 4096,
} as const);

export type SceneLimits = typeof SCENE_LIMITS;
